
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Plus } from "lucide-react";

interface LoadMoreButtonProps {
  isLoading: boolean;
  onClick: () => void;
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({ isLoading, onClick }) => {
  return (
    <div className="mt-12 text-center">
      <Button
        variant="outline"
        size="lg"
        onClick={onClick}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Loading...
          </>
        ) : (
          <>
            <Plus className="mr-2 h-4 w-4" />
            Load More Photos
          </>
        )}
      </Button>
    </div>
  );
};

export default LoadMoreButton;
